define('app-Agents/main',["./settings", "./modules/modules"], function (settings, modules) {
    return {
        run: function () {
            modules.forEach(function (module) {
                if (module && module.initialise) {
                    module.initialise(settings);
                }
            });
        }
    };
});
